import React from "react";
import {observer} from "mobx-react";
import css from './block1.module.scss'
import Block1Card1 from "./Block1Card1";
import Block1SearchFloor from "./Block1SearchFloor";
import Block1LeftCarousel from "./Block1LeftCarousel";
import Block1NewsPanel from "./Block1NewsPanel";
import Block1Card2 from "./Block1Card2";

const Index = (
    {
        navFloor
    }
) => {
    return (
        <div className={css.root}>
            <div className={css.container}>

                {/* banner */}
                {navFloor}

                {/* card1 */}
                <Block1Card1 className={css.card1}>
                    {/*搜索floor*/}
                    <Block1SearchFloor className={css.searchFloor}/>

                    <div className={css.bottomFloor}>
                        {/*轮播*/}
                        <Block1LeftCarousel className={css.carouselContainer}/>
                        {/*右侧包含 广告 登录 公告*/}
                        <div className={css.rightContainer}>
                            <div className={css.advWrapper}>
                                <img className={css.img} src={require('./img/block1右侧直播宣传.png')} alt=''/>
                            </div>
                            <Block1NewsPanel className={css.newsPanel}/>
                        </div>
                    </div>
                </Block1Card1>

                {/* card2 秒杀 */}
                <Block1Card2 className={css.card2}/>

            </div>
        </div>
    )
}

export default observer(Index)